// extracted by mini-css-extract-plugin
export var backdropBlur = "_k4-0";
export var contentCard = "_k4-5";
export var frame = "_k4-2";
export var image = "_k4-4";
export var imagePane = "_k4-3";
export var modal = "_k4-1";